export const cleanHtmlTags = (html) => {
  const div = document.createElement("div");
  div.innerHTML = html;
  let text = div.textContent || div.innerText;
  text = text.replace(/\[object Object\]/g, "")
             .replace(new RegExp(String.fromCharCode(160), "g"), " ");
  return text;
};
